import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useT } from '../i18n';

export const ConfirmModal = ({ isOpen, message, onConfirm, onCancel, danger = true, confirmLabel }) => {
  const t = useT();
  useEffect(() => {
    if (!isOpen) return;
    const handle = (e) => { if (e.key === 'Escape') onCancel(); };
    window.addEventListener('keydown', handle);
    return () => window.removeEventListener('keydown', handle);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  const accentColor = danger ? '#d20f39' : '#7AB8BB';

  return createPortal(
    <div
      className="fixed inset-0 flex items-center justify-center z-[10000]"
      style={{ background: 'rgba(45, 74, 90, 0.4)', backdropFilter: 'blur(8px)' }}
      onClick={(e) => e.target === e.currentTarget && onCancel()}
    >
      <div
        className="w-full mx-4 shadow-[0_20px_50px_rgba(0,0,0,0.2)] overflow-hidden"
        style={{ maxWidth: '440px', borderRadius: '28px', background: 'var(--bg)' }}
      >
        <div className="p-10 text-center">
          <div
            className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-8 shadow-inner"
            style={{ backgroundColor: `${accentColor}10`, color: accentColor }}
          >
            {danger ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg>
            )}
          </div>
          <h3 className="text-2xl font-extrabold mb-4" style={{ color: 'var(--text-primary)' }}>{t('confirmModal.title')}</h3>
          <p className="text-lg leading-relaxed px-2" style={{ color: 'var(--text-muted)' }}>{message}</p>
        </div>

        <div className="px-10 pb-10 flex gap-4">
          <button
            onClick={onCancel}
            className="flex-1 py-4 text-[15px] font-bold rounded-2xl transition-all active:scale-95"
            style={{ color: 'var(--text-muted)', background: 'var(--surface)' }}
          >
            {t('confirmModal.cancel')}
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-4 text-[15px] font-bold text-white rounded-2xl shadow-lg transition-all hover:scale-[1.02] active:scale-95"
            style={{ backgroundColor: accentColor, boxShadow: `0 10px 25px ${accentColor}40` }}
          >
            {confirmLabel ?? (danger ? t('confirmModal.delete') : t('confirmModal.confirm'))}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};
